import { useState } from "react";
import { ChevronDownIcon, CheckIcon } from "@heroicons/react/24/outline";

const RequesterMultiSelect = ({ label, selectedValues, setSelectedValues,error }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    "flipkart",
    "amazon",
    "paytm",
    "facebook",
    "instagram",
    "twitter",
    "linkedin",
    "whatsapp",
  ];

  const toggleSelection = (value) => {
    setSelectedValues((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value) // remove
        : [...prev, value] // add
    );
  };

  return (
    <div className="relative w-full">
      {/* Label */}
      <label className="block mb-1 text-sm font-bold text-black">
        {label}
        <span className="text-red-500 ms-2">*</span>
      </label>

      {/* Select Box */}
      <div
        className="border border-blue-600 rounded-md py-1 px-2 bg-white flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-gray-700 text-sm">
          {selectedValues.length > 0
            ? selectedValues.join(", ")
            : "Select Requesters"}
        </span>
        <ChevronDownIcon
          className={`w-5 h-5 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute mt-1 w-full border border-blue-500 rounded-md bg-white shadow-lg max-h-64 overflow-y-auto z-50">
          {options.map((option) => (
            <label
              key={option}
              className="flex items-center px-3 py-2 hover:bg-blue-50 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selectedValues.includes(option)}
                onChange={() => toggleSelection(option)}
                className="text-blue-600 rounded focus:ring-0"
              />
              <span className="ml-2 capitalize text-gray-700">{option}</span>
              {selectedValues.includes(option) && (
                <CheckIcon className="w-4 h-4 text-blue-600 ml-auto" />
              )}
            </label>
          ))}
        </div>
      )}
      {error && <p className="text-red-500 text-xs italic">{error}</p>} 
    </div>
  );
};

export default RequesterMultiSelect;
